// extracted by mini-css-extract-plugin
export default {"BladeContent":"📚19-10-2ovy7R"};